module.exports = __webpack_public_path__ + "img/blxk_code.66209014.jpg";